import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import OrganisationForm, { STATE_ADD } from '../components/OrganisationForm';
import axios from 'axios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class OrganisationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // modal: false,
      organisationList: [],
      selectedCompanyId: '',
      isEdit: false,
    };
  }

  // details = id => {
  //   const org = this.state.organisationList.find(e => e.orgId === id);
  //   this.props.history.push({
  //     pathname: '/organisation/details/' + id,
  //     data: org, // your data array of objects
  //   });
  // };

  // users = () => {
  //   this.props.history.push('/user');
  // };

  configureCompany = (action, id) => () => {
    console.log('=================', +id);
    if (id != undefined || (id != null && action == 'EDIT')) {
      this.setState({
        isEdit: true,
        selectedCompanyId: id,
      });
    } else {
      this.setState({
        isEdit: false,
        selectedCompanyId: '',
      });
    }

    this.setState({
      modal: !this.state.modal,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getOrganisationList();
    }
  };

  getOrganisationList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/company/getUserCompany', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ organisationList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getOrganisationList();
  }
  render() {
    return (
      <Page
        className="OrganisationPage"
        title="User Company"
        breadcrumbs={[{ name: 'User Company', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <div className="text-right mb-4">
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.configureCompany('ADD', null)}
                  >
                    Create
                  </Button>
                </div>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Contact</th>
                      <th>Address</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.organisationList.length < 1 && (
                      <tr>
                        <td colSpan="4">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Create' button to add new company
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.organisationList.length > 0 &&
                      this.state.organisationList.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.CompanyName}</td>
                            <td>{item.CompanyContact}</td>
                            <td>{item.CompanyAddress}</td>
                            <td>
                              <div className="ps-action-button">
                                <Button
                                  className="theme-button theme-button-secondary"
                                  onClick={this.configureCompany(
                                    'EDIT',
                                    item.CompanyID,
                                  )}
                                >
                                  Edit
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.configureCompany()}
          className={this.props.className}
          centered
        >
          <OrganisationForm
            history={this.props.history}
            onToggleModal={this.configureCompany}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}
export default OrganisationPage;
